import React, {Component} from 'react';
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {withFirestore, firestoreConnect, isLoaded, isEmpty} from "react-redux-firebase";
import {connect} from "react-redux";
import {UserIsAuthenticated} from "../../utils/AuthManager";
import {StyledButton} from "../../components/Buttons";
import withSubscriptionValidatorHoc from "../../components/auth/SubscriptionValidatorHOC";
import {CALL_DB_PATH, COMPANY_DB_PATH} from "../../constants/DB_PATHS";
import {BackgroundDiv} from "../../components/Containers";
import Navbar from "../../components/Navbar";
import CallListItem from "../../components/CallListItem";
import withMyCoordsHOC from "../../components/MyCoordsHOC";
import {Table, Tag,} from 'antd';
import { CaretLeftOutlined, CaretRightOutlined} from "@ant-design/icons"
import {SERVICE_TYPES} from "../../constants/ServiceTypes";
import {DETAILED_CALL_URL} from "../../constants/URLS";
import {distanceFromCoords} from "../../utils/DistanceFromCoords";
import moment from "moment";
import DistanceFromMe from "../../components/DistanceFromMe";
import CallHeader from "../../components/Headers/CallHeader";
import styled from "styled-components"
import {
    setPaginationStartAfter,
    setPaginationSteps
} from "../../redux/uxEnhance/action";
import { motion } from "framer-motion"
import {PRIMARY_COLOR, PRIMARY_GRAY, PRIMARY_TEXT_COLOR, SECONDARY_GRAY} from "../../constants/COLORS";
import BasicTablePage from "../../components/TableQueries/BasicTablePage";



class ExclusiveCalls extends Component {

    render() {
        return (
            <div style={{maxHeight: '100vh', boxSizing: 'border-box', overflow: 'auto'}}>
               <BasicTablePage
                   header={'Bejovo hivasok'}
                   queryWhere={[
                           ['active', '==', true],
                           ['taken', '==', false],
                           ['takenByCompany', '==', this.props.profile.companyId || '']
                   ]}
               />

            </div>
        );
    }
}

export default compose(
    connect(
        ({firebase: {auth, profile}}) => ({
            auth,
            profile
        })
    ),

    //UserIsAuthenticated,
    //withSubscriptionValidatorHoc,
)(ExclusiveCalls);